<template>
    <div id="error-page">
        <dh-logo class="absolute-pos absolute-justify absolute-align" size="300px" color-gear="#F1F2F5" style="z-index: -1;"/>
        <div style="text-align: center;">
            <div style="font-size: 50pt;">{{ code }}</div>
            <div style="font-size: 25pt;">{{ status }}</div>
            <p v-if="message">{{ message }}</p>
            <br v-else>
            <!--router link is not used to avoid navigation guards-->
            <el-link :href="href" type="primary">{{ hrefText }}</el-link>
            <div v-if="refreshLink" style="margin-top: 1em;">
                <el-link href="" type="primary" @click="history.go(0)">
                    Reload page
                </el-link>
            </div>
        </div>
    </div>
</template>

<script>
  import DhLogo from "./_icons/DhLogo";

  export default {
    name: "ErrorPage",
    components: {DhLogo},
    props: {
      code: String,
      status: String,
      message: String,
      href: String,
      hrefText: String,
      refreshLink: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style scoped>
    .absolute-pos {
        position: absolute;
    }
    .absolute-justify {
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
    }
    .absolute-align {
        top: 0;
        bottom: 10vh;
        margin-top: auto;
        margin-bottom: auto;
    }
    #error-page {
        display: grid;
        align-items: center;

        height: 90vh;
        color: var(--color);
    }
</style>
